var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post__content"},[_c('div',{staticClass:"post__audio"},[_c('Player',{attrs:{"src":_vm.post.attachmentPath}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }